import { MaintenanceRequest } from "../../../types/types";
import { api } from "../api";

/**
 * maintenanceSaveByVehicle
 *
 * Salva uma nova manutenção.
 *
 * POST /maintenances
 */
const maintenanceSaveByVehicle = async (
    token: string,
    model: MaintenanceRequest
) => {
    const response = await api.post(
        `/maintenances`,
        {
            ...model,
        },
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

    return response;
};

export default maintenanceSaveByVehicle;